import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';

import {AppComponent} from './app.component';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {EscapeHtmlPipe} from './shared/pipes/keep-html.pipe';
import {MessagesComponent} from './messages/messages.component';
import {AppRoutingModule} from './app-routing.module';
import {MaterializationComponent} from './search/object-detail/materialization/materialization.component';
import {ExpressionComponent} from './search/object-detail/expression/expression.component';
import {WorkComponent} from './search/object-detail/work/work.component';
import {NgbActiveModal, NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {HomeComponent} from './home/home.component';
import {NotFoundComponent} from './not-found/not-found.component';
import {FooterComponent} from './footer/footer.component';
import {FilterBlockComponent} from './search/search-list/filters/filter-block/filter-block.component';
import {FiltersComponent} from './search/search-list/filters/filters.component';
import {ResultsComponent} from './search/search-list/results/results.component';
import {FilterItemComponent} from './search/search-list/filters/filter-block/filter-item/filter-item.component';
import {ChoosenFiltersComponent} from './search/search-list/results/choosen-filters/choosen-filters.component';
import {
  ChoosenFilterComponent
} from './search/search-list/results/choosen-filters/choosen-filter/choosen-filter.component';
import {PaginationComponent} from './search/search-list/results/pagination/pagination.component';
import {ResultItemComponent} from './search/search-list/results/result-item/result-item.component';
import {SearchComponent} from './search/search.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {BrowseListComponent} from './search/browse-list/browse-list.component';
import {AppConfigService} from './config/app-config.service';
import {MuseumObjectComponent} from './search/object-detail/museum-object/museum-object.component';
import {SearchListComponent} from './search/search-list/search-list.component';
import {ObjectDetailComponent} from './search/object-detail/object-detail.component';
import {DescriptorComponent} from './descriptor/descriptor.component';
import {MetadataComponent} from './shared/metadata/metadata.component';
import {WorkDetailsComponent} from './search/object-detail/work/work-details/work-details.component';
import {
  MaterializationDetailsComponent
} from './search/object-detail/materialization/materialization-details/materialization-details.component';
import {SuggestionsComponent} from './search/suggestions/suggestions.component';
import {FilterEmptySuggestionsPipe} from './shared/pipes/filter-empty-suggestions.pipe';
import {SortListComponent} from './search/search-list/results/pagination/sort-list/sort-list.component';
import {
  MuseumObjectDetailsComponent
} from './search/object-detail/museum-object/museum-object-details/museum-object-details.component';
import {LinkyModule} from 'angular2-linky';
import {BottomListComponent} from './search/object-detail/bottom-list/bottom-list.component';
import {
  MaterializationListComponent
} from './search/object-detail/bottom-list/materialization-list/materialization-list.component';
import {GroupByPipe} from './shared/pipes/group-by.pipe';
import {FilterByPipe} from './shared/pipes/filter-by.pipe';
import {SortByPipe} from './shared/pipes/sort-by.pipe';
import {
  FilterDefaultComponent
} from './search/search-list/filters/filter-block/filter-default/filter-default.component';
import {FilterPhraseComponent} from './search/search-list/filters/filter-block/filter-phrase/filter-phrase.component';
import {
  FilterCommonHeaderComponent
} from './search/search-list/filters/filter-block/filter-common-header/filter-common-header.component';
import {FilterModalComponent} from './search/search-list/filters/filter-block/filter-modal/filter-modal.component';
import {FilterSelectComponent} from './search/search-list/filters/filter-block/filter-select/filter-select.component';
import {DialogModule} from './dialog/dialog.module';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {ToastrModule, ToastrService} from 'ngx-toastr';
import {FilterRangeComponent} from './search/search-list/filters/filter-block/filter-range/filter-range.component';
import {PlotsModule} from './plots/plots.module';
import {GuardModule} from './guard-module/guard.module';
import {BingMapsModule} from "./bing-maps/bing-maps.module";
import {
  FilterRangeQuickSelectComponent
} from './search/search-list/filters/filter-block/filter-range-quick-select/filter-range-quick-select.component';
import {BingMapsLoaderService} from "./bing-maps/service/bing-maps-loader.service";
import {BingMapService} from "./bing-maps/service/bing-map.service";
import {BreadcrumbComponent} from "./breadcrumb/breadcrumb/breadcrumb.component";
import {LogRoutingService} from "./log/log-routing.service";
import {LogModule} from "./log/log.module";
import {FulltextComponent} from './search/fulltext/fulltext.component';
import {InfoPagesModule} from "./info-pages/info-pages.module";
import {InfoPageComponent} from "./info-pages/info-page/info-page.component";
import {InfoPageService} from "./info-pages/info-page.service";
import {BreadcrumbModule} from "./breadcrumb/breadcrumb.module";
import {HtmlUtilsModule} from "./html-utils/html-utils.module";
import {FooterLinkComponent} from './footer/footer-link/footer-link.component';
import {MetadataTextComponent} from './shared/metadata/metadata-text/metadata-text.component';
import {MetadataLinksComponent} from './shared/metadata/metadata-links/metadata-links.component';
import {MetadataListComponent} from './shared/metadata/metadata-list/metadata-list.component';
import {NavBlockComponent} from './navbar/nav-block/nav-block.component';
import {NavAccountComponent} from './navbar/nav-account/nav-account.component';
import {NavBackComponent} from './navbar/nav-back/nav-back.component';
import {NavBrowseComponent} from './navbar/nav-browse/nav-browse.component';
import {NavLogoComponent} from './navbar/nav-logo/nav-logo.component';
import {NavSearchComponent} from './navbar/nav-search/nav-search.component';
import {NavHelpComponent} from './navbar/nav-help/nav-help.component';
import {NavLangComponent} from './navbar/nav-lang/nav-lang.component';
import {NavExtrasComponent} from './navbar/nav-extras/nav-extras.component';
import {NavNotificationComponent} from './navbar/nav-notification/nav-notification.component';
import {NavAccountListComponent} from './navbar/nav-account/nav-account-list/nav-account-list.component';
import {NavSearchBoxComponent} from './navbar/nav-search/nav-search-box/nav-search-box.component';
import {RouterModule} from "@angular/router";
import {ObjectTitleComponent} from './search/object-detail/object-title/object-title.component';
import {AccountModule} from "./auth/account/account.module";
import {ApplicationPipesModule} from './application-pipes-module/application-pipes.module';
import {FeedbackComponent} from './footer/feedback/feedback.component';
import {NgxCaptchaModule} from "ngx-captcha";
import {TranslateService} from './shared/translate.service';
import {PasswordPromptComponent} from "./auth/account/account/password-prompt/password-prompt.component";
import {SearchCacheService} from './search/search-cache.service';
import {ServerErrorComponent} from './home/server-error/server-error.component';
import {DeviceDetectorModule} from "ngx-device-detector";
import {ErrorComponent} from './home/server-error/error/error.component';
import {CoverComponent} from './search/object-detail/cover/cover.component';
import {ExtLinkModalComponent} from './search/object-detail/bottom-list/ext-link-modal/ext-link-modal.component';
import {VirtualScrollerModule} from 'ngx-virtual-scroller';
import {MetadataTabsComponent} from './shared/metadata/metadata-tabs/metadata-tabs.component';
import {StatisticsComponent} from "./search/object-detail/statistics/statistics.component";
import {UserItemDeletePromptComponent} from './auth/account/user-item-delete-prompt/user-item-delete-prompt.component';
import {MAT_DATE_LOCALE, MatExpansionModule, MatInputModule, MatListModule} from '@angular/material';
import {ListComponent} from './shared/list/list.component';
import {FacetsComponent} from './shared/list/facets/facets.component';
import {FacetBlockComponent} from './shared/list/facets/facet-block/facet-block.component';
import {FacetDefaultComponent} from './shared/list/facets/facet-block/facet-default/facet-default.component';
import {FacetPhraseComponent} from './shared/list/facets/facet-block/facet-phrase/facet-phrase.component';
import {FacetSelectComponent} from './shared/list/facets/facet-block/facet-select/facet-select.component';
import {FacetRangeComponent} from './shared/list/facets/facet-block/facet-range/facet-range.component';
import {
  FacetRangeQuickSelectComponent
} from './shared/list/facets/facet-block/facet-range-quick-select/facet-range-quick-select.component';
import {ResultListComponent} from './shared/list/result-list/result-list.component';
import {ChoosenFacetsComponent} from './shared/list/result-list/choosen-facets/choosen-facets.component';
import {PaginationListComponent} from './shared/list/result-list/pagination-list/pagination-list.component';
import {ResultObjectComponent} from './shared/list/result-list/result-object/result-object.component';
import {
  ResultObjectFulltextComponent
} from './shared/list/result-list/result-object-fulltext/result-object-fulltext.component';
import {ChoosenFacetComponent} from './shared/list/result-list/choosen-facets/choosen-facet/choosen-facet.component';
import {SortComponent} from './shared/list/result-list/pagination-list/sort/sort.component';
import {FacetItemComponent} from './shared/list/facets/facet-block/facet-item/facet-item.component';
import {UserQueryComponent} from './auth/account/user-queries/user-query/user-query.component';
import {UserCollectionComponent} from './auth/account/user-collections/user-collection/user-collection.component';
import {BingMapsMobileService} from "./bing-maps/service/bing-maps-mobile.service";
import {EuInfoComponent} from './navbar/nav-search/eu-info/eu-info.component';
import {LogoComponent} from './navbar/nav-search/eu-info/logo/logo.component';
import {ExternalAppsModule} from './external-apps/external-apps.module';
import {FiltersService} from './search/search-list/filters/filters.service';
import {FacetService} from './shared/list/facets/facet.service';
import {
  HideableFacetBlockComponent
} from './search/object-detail/bottom-list/hideable-facet-block/hideable-facet-block.component';
import {FacetModalComponent} from './shared/list/facets/facet-modal-component/facet-modal-component.component';
import {DownloadButtonComponent} from './search/download-button/download-button.component';
import {NotificationModule} from "./auth/notification/notification.module";
import {
  NavNotificationsListComponent
} from './navbar/nav-notification/nav-notifications-list/nav-notifications-list.component';
import {GoogleAnalyticsService} from './shared/google-analytics.service';
import {InstitutionsModule} from './institutions/institutions.module';
import {DeferLoadModule} from '@trademe/ng-defer-load';
import {
  FavouriteUserCollectionModalComponent
} from './auth/account/user-collections/favourite-user-collection-modal/favourite-user-collection-modal.component';
import {LibraryListModule} from './search/object-detail/bottom-list/library-list/library-list.module';
import {SiteMapModule} from './site-map/site-map.module';
import {QueryModule} from './query/query.module';
import {FilterTreeComponent} from './search/search-list/filters/filter-block/filter-tree/filter-tree.component';
import {WikiDataDatePipe} from './descriptor/pipes/wikiData-date.pipe';
import {DescriptorMetadataComponent} from './shared/descriptor-metadata/descriptor-metadata.component';
import {
  DescriptorMetadataTextComponent
} from './shared/descriptor-metadata/descriptor-metadata-text/descriptor-metadata-text.component';
import {
  DescriptorMetadataLinksComponent
} from './shared/descriptor-metadata/descriptor-metadata-links/descriptor-metadata-links.component';
import {
  DescriptorMetadataListComponent
} from './shared/descriptor-metadata/descriptor-metadata-list/descriptor-metadata-list.component';
import {
  DescriptorMetadataTabsComponent
} from './shared/descriptor-metadata/descriptor-metadata-tabs/descriptor-metadata-tabs.component';
import {
  DescriptorMetadataModalComponent
} from './shared/descriptor-metadata/descriptor-metadata-modal-component/descriptor-metadata-modal-component';
import {ClickOutsideModule} from 'ng-click-outside';
import {FacetTreeComponent} from './shared/list/facets/facet-block/facet-tree/facet-tree.component';
import {
  FilterTreeShowMoreModalComponent
} from './search/search-list/filters/filter-block/filter-tree/filter-tree-show-more-modal/filter-tree-show-more-modal.component';
import {IsbnDescriptionComponent} from './isbn-descriptor/isbn-description.component';
import {
  PaginationListArticlesComponent
} from './shared/list/result-list/pagination-list/pagination-list-articles.componant';
import {PublicDataViewComponent} from "./public-data-view/public-data-view.component";
import {
  PublicDataViewDetailsComponent
} from './public-data-view/public-data-view-details/public-data-view-details.component';
import {MetadataDetailsComponent} from './shared/descriptor-metadata/metadata-details/metadata-details.component';
import {
  DescriptorWikidataComponent
} from './shared/descriptor-metadata/descriptor-wikidata/descriptor-wikidata.component';
import {
  PersonalDescriptorMetadataComponent
} from './shared/personal-descriptor-metadata/personal-descriptor-metadata.component';
import {MatSelectModule} from "@angular/material/select";
import {NavLangListComponent} from './navbar/nav-lang/nav-lang-list/nav-lang-list.component';
import {LoginComponent} from './login/login.component';
import {ResetPasswordComponent} from './reset-password/reset-password.component';
import {RegistrationComponent} from './registration/registration.component';
import {MatIconModule} from "@angular/material/icon";
import {environment} from '../environments/environment';
import {RECAPTCHA_SETTINGS, RecaptchaFormsModule, RecaptchaModule, RecaptchaSettings} from 'ng-recaptcha';
import {AuthInterceptor} from "./auth/auth.interceptor";
import {AuthService} from "./auth/auth.service";

@NgModule({
  declarations: [
    AppComponent,
    EscapeHtmlPipe,
    MessagesComponent,
    SearchListComponent,
    ObjectDetailComponent,
    MaterializationComponent,
    ExpressionComponent,
    WorkComponent,
    HomeComponent,
    NotFoundComponent,
    FooterComponent,
    FilterBlockComponent,
    FiltersComponent,
    ResultsComponent,
    FilterItemComponent,
    ChoosenFiltersComponent,
    ChoosenFilterComponent,
    PaginationComponent,
    ResultItemComponent,
    SearchComponent,
    BrowseListComponent,
    MuseumObjectComponent,
    WikiDataDatePipe,
    DescriptorComponent,
    MetadataComponent,
    DescriptorMetadataComponent,
    WorkDetailsComponent,
    MaterializationDetailsComponent,
    SuggestionsComponent,
    FilterEmptySuggestionsPipe,
    DescriptorComponent,
    SortListComponent,
    SortListComponent,
    MuseumObjectDetailsComponent,
    BottomListComponent,
    MaterializationListComponent,
    GroupByPipe,
    FilterByPipe,
    SortByPipe,
    FilterDefaultComponent,
    FilterTreeComponent,
    FilterPhraseComponent,
    FilterCommonHeaderComponent,
    FilterModalComponent,
    FilterSelectComponent,
    FilterRangeComponent,
    FilterRangeQuickSelectComponent,
    FilterTreeShowMoreModalComponent,
    BreadcrumbComponent,
    InfoPageComponent,
    FulltextComponent,
    FooterLinkComponent,
    MetadataTextComponent,
    MetadataLinksComponent,
    MetadataListComponent,
    DescriptorMetadataTextComponent,
    DescriptorMetadataLinksComponent,
    DescriptorMetadataListComponent,
    DescriptorMetadataModalComponent,
    NavBlockComponent,
    NavAccountComponent,
    NavBackComponent,
    NavBrowseComponent,
    NavLogoComponent,
    NavSearchComponent,
    NavHelpComponent,
    NavLangComponent,
    NavExtrasComponent,
    NavNotificationComponent,
    NavAccountListComponent,
    NavSearchBoxComponent,
    ObjectTitleComponent,
    FeedbackComponent,
    ServerErrorComponent,
    ErrorComponent,
    CoverComponent,
    ExtLinkModalComponent,
    MetadataTabsComponent,
    DescriptorMetadataTabsComponent,
    StatisticsComponent,
    ListComponent,
    FacetsComponent,
    FacetBlockComponent,
    FacetDefaultComponent,
    FacetPhraseComponent,
    FacetTreeComponent,
    FacetSelectComponent,
    FacetRangeComponent,
    FacetRangeQuickSelectComponent,
    ResultListComponent,
    ChoosenFacetsComponent,
    PaginationListComponent,
    PaginationListArticlesComponent,
    ResultObjectComponent,
    ResultObjectFulltextComponent,
    ChoosenFacetComponent,
    SortComponent,
    FacetItemComponent,
    StatisticsComponent,
    EuInfoComponent,
    LogoComponent,
    HideableFacetBlockComponent,
    FacetModalComponent,
    DownloadButtonComponent,
    DownloadButtonComponent,
    NavNotificationsListComponent,
    FavouriteUserCollectionModalComponent,
    IsbnDescriptionComponent,
    PublicDataViewComponent,
    PublicDataViewDetailsComponent,
    MetadataDetailsComponent,
    DescriptorWikidataComponent,
    PersonalDescriptorMetadataComponent,
    NavLangListComponent,
    LoginComponent,
    ResetPasswordComponent,
    RegistrationComponent
  ],
    imports: [
        NgbModule.forRoot(),
        BrowserModule,
        InstitutionsModule,
        SiteMapModule,
        HttpClientModule,
        AppRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        LinkyModule,
        BrowserAnimationsModule,
        DialogModule,
        ToastrModule,
        PlotsModule,
        LogModule,
        BingMapsModule,
        InfoPagesModule,
        BreadcrumbModule,
        GuardModule,
        HtmlUtilsModule,
        RouterModule,
        AccountModule,
        ApplicationPipesModule,
        VirtualScrollerModule,
        ExternalAppsModule,
        NotificationModule,
        NgxCaptchaModule,
        MatListModule,
        MatInputModule,
        MatExpansionModule,
        LibraryListModule,
        DeferLoadModule,
        QueryModule,
        ClickOutsideModule,
        DeviceDetectorModule.forRoot(),
        MatSelectModule,
        MatIconModule,
        RecaptchaModule,
        RecaptchaFormsModule
    ],
  exports: [
  ],
  providers: [
    AppConfigService,
    GoogleAnalyticsService,
    ToastrService,
    BingMapsLoaderService,
    BingMapService,
    BingMapsMobileService,
    LogRoutingService,
    InfoPageService,
    SearchCacheService,
    FiltersService,
    FacetService,
    FilterItemComponent,
    NgbActiveModal,
    { provide: MAT_DATE_LOCALE, useValue: 'pl-PL' },
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: {
        siteKey: environment.recaptcha.siteKey,
      } as RecaptchaSettings,
    },
    FiltersComponent,
    AuthService,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
  entryComponents: [
    FilterModalComponent,
    DescriptorMetadataModalComponent,
    FacetModalComponent,
    FilterTreeShowMoreModalComponent,
    FeedbackComponent,
    PasswordPromptComponent,
    ExtLinkModalComponent,
    UserItemDeletePromptComponent,
    UserQueryComponent,
    UserCollectionComponent,
    FavouriteUserCollectionModalComponent,
  ]
})
export class AppModule {
}
